import { Button, Modal } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";

const SkipModal = ({
  open,
  onClose,
  handleNextStep,
  innerStepper,
  formik,
  IS_EXPENSES,
  IS_INCOME,
  skipContent,
  handleEditableStep,
  onFinish,
}) => {
  const { t } = useTranslation();
  const handleSkip = () => {
    if (IS_EXPENSES) {
      onFinish(formik?.values, true);
    } else if (IS_INCOME) {
      onFinish(formik?.values, true);
    } else {
      handleNextStep();
    }
    handleEditableStep(null);
    onClose();
  };
  return (
    <>
      <Modal
        width="500px"
        title={false}
        open={open}
        onOk={onClose}
        onCancel={onClose}
        className="custom-common-modal"
        centered
        closeIcon={false}
        footer={false}
      >
        <div className="row modal-main-inner-row">
          <div className="col-12 text-center">
            <img
              src="/assets/images/icons/skip-icon.svg"
              className="img-fluid"
              alt=""
            />
            {skipContent ? (
              <div dangerouslySetInnerHTML={{ __html: skipContent }}></div>
            ) : (
              <>
                <h1>Are you sure you want to skip this question?</h1>
                <p>
                  This is a recommended question and it will help us to make
                  your budget statistics accurately.
                </p>
              </>
            )}
            <div className="row modal-footer-row">
              <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                <Button onClick={onClose}>
                  {t("expenses.ques17.options.2")}
                </Button>
              </div>
              <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                <Button
                  type="primary"
                  onClick={(e) => {
                    e.preventDefault();
                    handleSkip();
                  }}
                >
                  {t("expenses.ques17.options.1")}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default SkipModal;
